import { createTranslationRef } from '@backstage/core-plugin-api/alpha';
import enMessages from './translations/en.json';

export const ciandtspikeOnboardingTranslationRef = createTranslationRef({
  id: 'plugin.ciandtspike-onboarding',
  messages: enMessages,
});
